
const PWD_REG = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,16}$/;

export default {
  name: "PasswordModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isPassword: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    rules() {
      const validateNewPwd = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("page.PASSWORD_REQUIRED")));
        } else if (!PWD_REG.test(value)) {
          callback(new Error(this.$t("page.PASSWORD_FORMAT_ERROR")));
        } else {
          if (this.form.confirmPassword) {
            this.$refs.form.validateField("confirmPassword");
          }
          callback();
        }
      };
      const validateConfirmPwd = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("page.CONFIRM_PASSWORD_REQUIRED")));
        } else if (value !== this.form.newPassword) {
          callback(new Error(this.$t("page.PASSWORDS_DO_NOT_MATCH")));
        } else {
          callback();
        }
      };
      return {
        oldPassword: [
          { required: true, message: this.$t("page.CURRENT_PASSWORD_REQUIRED"), trigger: "blur" },
        ],
        newPassword: [{ validator: validateNewPwd, trigger: "blur" }],
        confirmPassword: [{ validator: validateConfirmPwd, trigger: "blur" }],
      };
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.resetFields();
        });
      }
    },
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          const payload = {
            newPassword: this.form.newPassword,
            confirmPassword: this.form.confirmPassword,
          };
          if (this.isPassword) {
            payload.oldPassword = this.form.oldPassword;
          }
          const res = await this.$global.userInfoUploadPassword(payload);
          if (res.code == 200) {
            this.$message.success(res.msg || this.$t("page.PASSWORD_UPDATED"));
            this.$emit("update:visible", false);
            this.$emit("success");
          } else {
            this.$message.error(res.msg || this.$t("page.PASSWORD_UPDATE_FAILED"));
          }
        } catch (err) {
          console.error("Password update error:", err);
          this.$message.error(this.$t("page.SYSTEM_ERROR_RETRY"));
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
